export * from "./index.shared.js";
export { registerApolloClient } from "@apollo/client-react-streaming";
export type {
  PreloadQueryComponent,
  PreloadQueryProps,
} from "@apollo/client-react-streaming";
